import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-invoice-page',
  templateUrl: './invoice-page.component.html',
  styleUrls: ['./invoice-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoicePageComponent {
  shippingAccountingVisible = false;
}

